/* eslint-disable no-restricted-syntax -- Not translatable strings */
import type { ComponentPropsWithoutRef } from "react";
import classNames from "classnames";
import { t } from "@/i18n-js/instance";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { IconButton } from "../HeaderV3/IconButton";
import type { Variable } from "./InsertVariableButtonWrapper";
import { InsertVariableButtonWrapper } from "./InsertVariableButtonWrapper";

const memberGroupLabel = t("dynamic_vars_groups.member");

export const DEFAULT_VARIABLES: Variable[] = [
  {
    group: memberGroupLabel,
    label: "{{member.first_name}}",
    value: "{{member.first_name}}",
  },
  {
    group: memberGroupLabel,
    label: "{{member.last_name}}",
    value: "{{member.last_name}}",
  },
  {
    group: memberGroupLabel,
    label: "{{member.name}}",
    value: "{{member.name}}",
  },
  {
    group: memberGroupLabel,
    label: "{{member.email}}",
    value: "{{member.email}}",
  },
  {
    group: memberGroupLabel,
    label: "{{member.public_uid}}",
    value: "{{member.public_uid}}",
  },
];

interface InsertVariableButtonProps
  extends Omit<
    ComponentPropsWithoutRef<typeof InsertVariableButtonWrapper>,
    "children"
  > {
  className?: string;
  tooltipPlacement?: "top" | "bottom";
}

export const InsertVariableButton = ({
  tooltipPlacement = "bottom",
  className,
  ...rest
}: InsertVariableButtonProps) => (
  <InsertVariableButtonWrapper {...rest}>
    <TippyV2
      placement={tooltipPlacement}
      delay={300}
      content={t("tiptap.add_variable")}
      interactive={false}
    >
      <IconButton
        iconSize={20}
        buttonSize={32}
        name="20-variables"
        className={classNames(
          "disabled:cursor-not-allowed disabled:opacity-40",
          className,
        )}
        ariaLabel={t("tiptap.add_variable")}
      />
    </TippyV2>
  </InsertVariableButtonWrapper>
);
